export default __webpack_public_path__ + "static/media/papajoe6.020ae711.jpg";